import clsx from 'clsx';
import dayjs from 'dayjs';
import React from 'react';
import { factory } from '../../../factory/factory.utils.mjs';
import { Typography } from '../../../Foundations/Typography/Typography.mjs';
import '../DatesProvider/DatesProvider.mjs';
import { useDatesContext } from '../DatesProvider/use-dates-context.mjs';
import classes from './Day.module.css.mjs';
import { shiftTimezone } from './Day.utils.mjs';

const Day = factory((props, ref) => {
  const { className, style, date, disabled, weekend, outside, selected, renderDay, hidden, isStatic, ...rest } = props;
  const ctx = useDatesContext();
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /* @__PURE__ */ React.createElement(
      Typography,
      {
        size: "label-regular-s",
        className: clsx(className, classes.day),
        style: { ...style },
        component: isStatic ? "div" : "button",
        type: isStatic ? void 0 : "button",
        ref,
        disabled,
        "aria-disabled": disabled || void 0,
        "aria-selected": !disabled && selected || void 0,
        "data-today": dayjs(date).isSame(shiftTimezone("add", /* @__PURE__ */ new Date(), ctx.getTimezone()), "day") || void 0,
        "data-hidden": hidden || void 0,
        "data-disabled": disabled || void 0,
        "data-weekend": !disabled && !outside && weekend || void 0,
        "data-outside": !disabled && outside || void 0,
        "data-selected": !disabled && selected || void 0,
        "data-static": isStatic || void 0,
        ...rest
      },
      renderDay?.(date) || date.getDate()
    )
  );
});

export { Day };
